import PropTypes from 'prop-types'
import React from 'react'

import Headshot from './Headshot'

import './CommitteeMember.css'

const VOTE_LABELS = {
  'Yea': '👍',
  'Nay': '👎',
  'Absent': '🤷'
}

const voteLabel = voteText => {
  return VOTE_LABELS[voteText]
}

const voteCell = (voteId, voteText) => <td key={voteId} className="CommitteeMember-vote"><span title={voteText}>{voteLabel(voteText)}</span></td>

const CommitteeMember = ({member, marker, headshot, votes, onClickWard}) => {
  let voteCols = null

  if (votes && member.votes) {
    voteCols = votes.map(v => voteCell(v.ordinance_id, member.votes[v.ordinance_id]))
  }

  return (
    <tr key={member.ward}>
      <td>{marker}</td>
      <td>{member.ward}</td>
      <td className="MemberList-headshot-col"><Headshot headshot={headshot} alt={member.name} /></td>
      <td><button className="CommitteeMember-name-btn" onClick={() => onClickWard(member)}>{member.name}</button></td>
      {voteCols}
    </tr>
  )
}

CommitteeMember.propTypes = {
  member: PropTypes.object,
  marker: PropTypes.string,
  headshot: PropTypes.string,
  votes: PropTypes.array,
  onClickWard: PropTypes.func
}

export default CommitteeMember



// WEBPACK FOOTER //
// ./src/CommitteeMember.js